/** "Designation · Department", skipping whichever is unset. */
export function roleLine(designation?: string | null, department?: string | null): string {
  return [designation, department].filter(Boolean).join(' · ');
}
